import {
  ArchiveIcon,
  ArrowsClockwiseIcon,
  BookIcon,
  BookBookmarkIcon,
  FileArchiveIcon,
  FrameCornersIcon,
  FunnelSimpleIcon,
  GraphIcon,
  KeyIcon,
  ListMagnifyingGlassIcon,
  PlugsIcon,
  SignOutIcon,
  TerminalWindowIcon,
  UserGearIcon,
  UserListIcon,
  WebhooksLogoIcon,
} from '@phosphor-icons/react';
import {
  IconCaution,
  IconCompany,
  IconCompose,
  IconHistory,
  IconHome,
  IconNotification,
  IconPeople,
  IconRenderer,
  IconResume,
  IconSecurity,
  IconStatistics,
  IconTip,
  IconZoomIn,
  type Text,
} from 'braid-design-system';
import type { ComponentProps } from 'react';

import type { PageIconId } from '#src/page.ts';

export const PageIcon = ({
  icon,
}: {
  icon: PageIconId;
}): ComponentProps<typeof Text>['icon'] => {
  switch (icon) {
    case 'AdPerformance':
      return <IconStatistics />;

    case 'AdSync':
      return (
        <IconRenderer>
          {({ className }) => <ArrowsClockwiseIcon className={className} />}
        </IconRenderer>
      );

    case 'ApplyWithSeek':
      return (
        <IconRenderer>
          {({ className }) => <UserListIcon className={className} />}
        </IconRenderer>
      );

    case 'Auth':
      return (
        <IconRenderer>
          {({ className }) => <KeyIcon className={className} />}
        </IconRenderer>
      );

    case 'DeveloperDashboard':
      return (
        <IconRenderer>
          {({ className }) => <TerminalWindowIcon className={className} />}
        </IconRenderer>
      );

    case 'Documentation':
      return (
        <IconRenderer>
          {({ className }) => <BookIcon className={className} />}
        </IconRenderer>
      );

    case 'GraphQL':
      return (
        <IconRenderer>
          {({ className }) => <GraphIcon className={className} />}
        </IconRenderer>
      );

    case 'Guide':
      return (
        <IconRenderer>
          {({ className }) => <BookIcon className={className} />}
        </IconRenderer>
      );

    case 'GuideArchive':
      return (
        <IconRenderer>
          {({ className }) => <ArchiveIcon className={className} />}
        </IconRenderer>
      );

    case 'GuideFileArchive':
      return (
        <IconRenderer>
          {({ className }) => <FileArchiveIcon className={className} />}
        </IconRenderer>
      );

    case 'GuideIndex':
      return (
        <IconRenderer>
          {({ className }) => <BookBookmarkIcon className={className} />}
        </IconRenderer>
      );

    case 'Home':
      return <IconHome />;

    case 'Introduction':
      return <IconTip />;

    case 'JobPosting':
      return <IconCompose />;

    case 'Logout':
      return (
        <IconRenderer>
          {({ className }) => <SignOutIcon className={className} />}
        </IconRenderer>
      );

    case 'Monitoring':
      return <IconZoomIn />;

    case 'MonitoringAndTroubleshooting':
      return <IconCaution />;

    case 'Notifications':
      return <IconNotification />;

    case 'OptimisedApply':
      return <IconResume />;

    case 'Organizations':
      return <IconCompany />;

    case 'Panel':
      return (
        <IconRenderer>
          {({ className }) => <FrameCornersIcon className={className} />}
        </IconRenderer>
      );

    case 'ReleaseNotes':
      return <IconHistory />;

    case 'Schema':
      return (
        <IconRenderer>
          {({ className }) => <ListMagnifyingGlassIcon className={className} />}
        </IconRenderer>
      );

    case 'Signals':
      return (
        <IconRenderer>
          {({ className }) => <FunnelSimpleIcon className={className} />}
        </IconRenderer>
      );

    case 'SSO':
      return (
        <IconRenderer>
          {({ className }) => <KeyIcon className={className} />}
        </IconRenderer>
      );

    case 'StatusPage':
      return (
        <IconRenderer>
          {({ className }) => <PlugsIcon className={className} />}
        </IconRenderer>
      );

    case 'TalentSearchConnect':
      return <IconPeople />;

    case 'UserProfile':
      return (
        <IconRenderer>
          {({ className }) => <UserGearIcon className={className} />}
        </IconRenderer>
      );

    case 'Users':
      return (
        <IconRenderer>
          {({ className }) => <UserListIcon className={className} />}
        </IconRenderer>
      );

    case 'Webhook':
      return (
        <IconRenderer>
          {({ className }) => <WebhooksLogoIcon className={className} />}
        </IconRenderer>
      );
    case 'Security':
      return <IconSecurity />;
  }
};
